module.exports = __webpack_public_path__ + "assets/img/driver-btn-347cf2fa.png";